<template>
  <div id="address-modal">
    <b-modal id="address-modal" hide-footer title="Editando Dirección">
      <EditAddress :address="address" @hideForm="hideModal" />
    </b-modal>
  </div>
</template>
<script>
import EditAddress from "../components/EditAddress.vue";
export default {
  name: "AddressModal",
  props: ["address"],
  components: {
    EditAddress,
  },
  methods: {
    hideModal(value) {
      if (!value) {
        this.$bvModal.hide("address-modal");
      }
    },
  },
};
</script>